import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DEFAULT_PAGE_SIZE } from "src/exercise/exerciseListQuery";
import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationExercisesPage } from "src/pages/OrganizationExercisesPage";
import { createOrganizationExercisesRepository } from "src/repositories/exercises/createOrganizationExercisesRepository";

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  muscleGroup: z.array(z.string()).optional(),
  category: z.array(z.string()).optional(),
  movementPattern: z.array(z.string()).optional(),
  showGlobal: z.boolean().optional(),
  showOwned: z.boolean().optional(),
});

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/exercises/")({
  component: OrganizationExercisesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => ({
    q: search.q ?? "",
    pageIndex: search.p ?? 0,
    pageSize: search.ps ?? DEFAULT_PAGE_SIZE,
    muscleGroup: search.muscleGroup,
    category: search.category,
    movementPattern: search.movementPattern,
    showGlobal: search.showGlobal,
    showOwned: search.showOwned,
  }),
  async loader({ context, deps, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        const exercisesRepository = createOrganizationExercisesRepository(
          organization.id,
        );
        await context.queryClient.query({
          ...exercisesRepository.listOptions(deps),
          staleTime: "static",
        });
        return { data: null };
      },
    );
  },
});
